import { render, staticRenderFns } from "./contract-change.vue?vue&type=template&id=2a8113b4&scoped=true"
import script from "./contract-change.vue?vue&type=script&lang=js"
export * from "./contract-change.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/style-review.css?vue&type=style&index=0&id=2a8113b4&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8113b4",
  null
  
)

export default component.exports